import styled from 'styled-components'
export const BannerWrap=styled.div`
.productgrid_banner{
   width:100%;
   mask-image: linear-gradient(to bottom,rgba(0,0,0,.8),rgba(0,0,0,0));
   z-index: -10;
   margin-bottom: -10%;}
`

